export default "/img/OM.02451de636126b8bc264d3f76ca69d0b.png";